import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import {
  chutexLoginWithPassword,
  clearChutexCredentials,
  comptaLoginWithPassword,
  logoutComptaSession,
  rgpdLoginWithPassword,
  verifyChutexSession,
} from '../lib/chutexAuth';

const ChutexAuthContext = createContext(null);

export function ChutexAuthProvider({ children }) {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const ok = await verifyChutexSession();
      if (!cancelled) {
        setAuthenticated((current) => current || ok);
        setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const login = useCallback(async (password) => {
    await chutexLoginWithPassword(password);
    setAuthenticated(true);
  }, []);

  const loginCompta = useCallback(async (password) => {
    await comptaLoginWithPassword(password);
    setAuthenticated(true);
  }, []);

  const loginRgpd = useCallback(async (password) => {
    await rgpdLoginWithPassword(password);
    setAuthenticated(true);
  }, []);

  const logout = useCallback(async () => {
    try {
      await logoutComptaSession();
    } finally {
      clearChutexCredentials();
      setAuthenticated(false);
    }
  }, []);

  const value = useMemo(() => ({
    authenticated,
    loading,
    login,
    loginCompta,
    loginRgpd,
    logout,
    isAuthenticated: authenticated,
  }), [authenticated, loading, login, loginCompta, loginRgpd, logout]);

  return <ChutexAuthContext.Provider value={value}>{children}</ChutexAuthContext.Provider>;
}

export function useChutexAuth() {
  const ctx = useContext(ChutexAuthContext);
  if (!ctx) throw new Error('useChutexAuth requis dans ChutexAuthProvider');
  return ctx;
}
